export function formatDateToDDMMYYYYString(date) {
  if (!date || date == null) return ''
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mm = date.toLocaleString('en-CA', { month: '2-digit' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return dd + '/' + mm + '/' + yyyy
}

export function formatDateToDDMMMMYYYYString(date) {
  const dd = date.toLocaleString('en-CA', { day: 'numeric' })
  const mmmm = date.toLocaleString('en-CA', { month: 'long' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return dd + ' ' + mmmm + ' ' + yyyy
}

export function formatDateToDDMMYYString(date) {
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mm = date.toLocaleString('en-CA', { month: '2-digit' })
  const yy = date.toLocaleString('en-CA', { year: '2-digit' })
  return dd + '/' + mm + '/' + yy
}

export function formatDateToDDMMMYYYYString(date) {
  if (!date) return '-'
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mmm = date.toLocaleString('en-CA', { month: 'short' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return dd + ' ' + mmm + ' ' + yyyy
}

export function formatDateToDDMMMYYYYHHmmString(date) {
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mmm = date.toLocaleString('en-CA', { month: 'short' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  var HH = ('0' + date.getHours()).slice(-2)
  var mm = ('0' + date.getMinutes()).slice(-2)
  return dd + ' ' + mmm + ' ' + yyyy + ' • ' + HH + ':' + mm
}

export function formatDateToHHmmString(date) {
  if (!date) return ''
  var HH = ('0' + date.getHours()).slice(-2)
  var mm = ('0' + date.getMinutes()).slice(-2)
  return HH + ':' + mm
}

export function formatDateToDDDDYYYYString(date) {
  const mmmm = date.toLocaleString('en-CA', { month: 'long' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return mmmm + ' ' + yyyy
}

export function formatDateToIsoString(date) {
  if (!date || date == null) return ''
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mm = date.toLocaleString('en-CA', { month: '2-digit' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return yyyy + '-' + mm + '-' + dd
}
export function formatDateToTHDDMMMMYYYYString(date) {
  return date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function formatDateToTHDDMMMMYYString(date) {
  return date.toLocaleDateString('th-TH', {
    year: 'short',
    month: 'long',
    day: 'numeric',
  })
}
export function formatDateToMMYYString(date) {
  const yy = date.toLocaleString('en-CA', { year: '2-digit' })
  const mm = date.toLocaleString('en-CA', { month: 'short' })
  return mm + ' ' + yy
}

export function formatDateToMMYYYYString(date) {
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  const mm = date.toLocaleString('en-CA', { month: 'short' })
  return mm + ' ' + yyyy
}

export function formatDateToYYYYMMDDString(date) {
  const dd = date.toLocaleString('en-CA', { day: '2-digit' })
  const mm = date.toLocaleString('en-CA', { month: '2-digit' })
  const yyyy = date.toLocaleString('en-CA', { year: 'numeric' })
  return yyyy + '-' + mm + '-' + dd
}
